/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  TableWellness,
  ShadowTableColumn,
  TableAverage,
  TeamAverageRow,
  StickyTableHead,
  ShadowSummaryColumn,
  ColumnContainerSummary,
  ArrowHolderSummary,
  LocationWrapper,
  TeamNamePopUp,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
} from './styles';
import { SelectPlayerColumn, Radio, InputCheckbox } from '..';
import Utils, { deepGet } from '../../utils/api/Utils';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';
import { Oval } from '../../pages/players/styles';

function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [radio, useRadio] = useState<any>({ one: false, two: false });
  const [check, useCheck] = useState<any>({ zone_1: false, zone_2: false, zone_3: false });

  useEffect(() => {
    // UTILS.HandleSorted(data, sortOptions);
    if (status) buildFilter();
  }, [radio]);
  useEffect(() => {
    if (status) buildFilter();
  }, [check]);
  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'Watch';
      }
      if (item === 'zone_2') {
        item = 'Warning';
      }
      if (item === 'zone_3') {
        item = 'Medical';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }
  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = { one: true, two: false };
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = { one: false, two: true };
      useReverse(true);
      useRadio(ascendent);
    }
  }
  if (visible === popup_id) {
    return (
      <SortPopUp>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{ border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px' }} />

            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })}>Watch</PopUpText>
              <Oval size={'16'} color={'yellow'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })}>Warning</PopUpText>
              <Oval size={'16'} color={'red'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_3} onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })}>Medical</PopUpText>
              <Oval size={'16'} color={'blue'} />
            </CheckBoxWrapper>
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}
export function Tooltip({ data, tooltip }: { data: Array<any>; tooltip: any }) {
  if (tooltip?.visible) {
    if (data?.length > 0) {
      return (
        <TeamNamePopUp posX={tooltip.posX} posY={tooltip.posY}>
          {data?.map((item, index) => {
            if (index === data.length - 1) {
              return <div key={item + 'popUp' + tooltip.posX}>{item}</div>;
            } else {
              return <div key={item + 'popUp' + tooltip.posX}>{item + ','}</div>;
            }
          })}
        </TeamNamePopUp>
      );
    } else {
      return <></>;
    }
  } else {
    return <></>;
  }
}
const PopUpGenerator = ({ name, title, data, changeFunction, location, visible, statusLocation, toggleFunction }) => {
  return (
    <StickyTableHead topPosition="64px" topPositionResponsive="41px">
      <span onClick={() => toggleFunction(name)}>{title}</span>

      <PopUp
        table={data}
        useTable={changeFunction}
        data={location}
        popup_id={name}
        visible={visible}
        includeAlerts={true}
        status={statusLocation}
      />
    </StickyTableHead>
  );
};

export default ({
  dataTableContent,
  teamAverage,
  dataCy,
  minWidth,
  filter,
  handleSort,
  sortBy,
  sortOrder,
}: {
  dataTableContent: Array<any>;
  teamAverage?: any;
  dataCy?: string;
  minWidth?: string;
  filter: string;
  handleSort: (key: string) => void;
  sortBy: string;
  sortOrder: string;
}) => {
  const [table, useTable] = useState<Array<any>>([...dataTableContent]);
  const [popUp, usePopup] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, [...table]];
  const UTILS = new Utils();

  useEffect(() => {
    useTable([...dataTableContent]);
  }, [dataTableContent]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useReverse(!reverse);
    UTILS.SortDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function sortingTableHead(title: string = '', attr: string, location: Array<any>, sortFunction) {
    return (
      <StickyTableHead topPosition="64px" topPositionResponsive="41px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sortBy === attr && sortOrder === 'desc' && <GoChevronDown size={14} />}
            {sortBy === attr && sortOrder === 'asc' && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHead>
    );
  }
  function playerStatus(status: string) {
    switch (status) {
      case 'Watch':
        return <Oval size={'8'} color={'yellow'} margin={'0px 0px 0px 3px'} />;

      case 'Warning':
        return <Oval size={'8'} color={'red'} margin={'0px 0px 0px 3px'} />;

      case 'Medical':
        return <Oval size={'8'} color={'blue'} margin={'0px 0px 0px 3px'} />;

      default:
        return;
    }
  }
  function takeInitials(string, separator) {
    return string
      .split(separator)
      .map(element => element[0])
      .join('');
  }
  function formatLocationCell(item, blockField, locationField, takeInitialsFunction, separator) {
    const summary = item?.summary;
    if (!summary) {
      return <span>-</span>;
    }

    const block = summary[blockField];

    if (!block) {
      return <span>-</span>;
    }

    const location = block[locationField];
    if (!location) {
      return <span>-</span>;
    }

    if (location.length > 1) {
      return location.map((element, idx) => {
        if (idx === location.length - 1) {
          return <span key={element + idx + item._id}>{takeInitialsFunction(element, separator)}</span>;
        } else {
          return <span key={element + idx + item._id}>{takeInitialsFunction(element, separator) + ', '}</span>;
        }
      });
    } else if (location.length === 1) {
      return location.map((element, idx) => {
        if (element.includes('Other') || element.includes('other')) {
          return <span key={element + idx + item._id}>Other</span>;
        } else {
          return <span key={element + idx + item._id}>{element}</span>;
        }
      });
    }

    return <span>-</span>;
  }

  const GenerateColumn = ({ index, item }) => {
    const [tooltip, useTooltip] = useState({ visible: false, posX: 0, posY: 0 });
    function changeTooltip(event, value) {
      useTooltip({ visible: value, posX: event.clientX, posY: event.clientY });
    }
    const [tooltipTwo, useTooltipTwo] = useState({ visible: false, posX: 0, posY: 0 });
    const [tooltipThree, useTooltipThree] = useState({ visible: false, posX: 0, posY: 0 });
    function changeTooltipTwo(event, value) {
      useTooltipTwo({ visible: value, posX: event.clientX, posY: event.clientY });
    }
    function changeTooltipThree(event, value) {
      useTooltipThree({ visible: value, posX: event.clientX, posY: event.clientY });
    }
    return (
      <tr key={index + item.firstName}>
        <SelectPlayerColumn player={item} />
        <td>{item?.summary?.dailyCheckIn?.date || '-'}</td>

        <ShadowTableColumn>
          {item?.summary?.dailyCheckIn?.armCurrent || '-'}
          {playerStatus(item?.summary?.dailyCheckIn?.armStatus)}
        </ShadowTableColumn>
        <LocationWrapper
          onMouseEnter={e => changeTooltip(e, true)}
          onMouseLeave={e => changeTooltip(e, false)}
          onWheel={() => useTooltip({ ...tooltip, visible: false })}>
          {formatLocationCell(item, 'dailyCheckIn', 'armLocation', takeInitials, ' - ')}

          <Tooltip data={item?.summary?.dailyCheckIn?.armLocation} tooltip={tooltip} />
        </LocationWrapper>

        <ShadowTableColumn>{item?.summary?.dailyCheckIn?.armLast7DaysAvg || '-'}</ShadowTableColumn>

        <td>
          {item?.summary?.dailyCheckIn?.bodyCurrent || '-'}
          {playerStatus(item?.summary?.dailyCheckIn?.bodyStatus)}
        </td>
        <td>{item?.summary?.dailyCheckIn?.bodyLast7DaysAvg || '-'}</td>
        <ShadowTableColumn>
          {item?.summary?.dailyCheckIn?.sleepCurrent || '-'}
          {playerStatus(item?.summary?.dailyCheckIn?.sleepStatus)}
        </ShadowTableColumn>
        <ShadowTableColumn>{item?.summary?.dailyCheckIn?.sleepLast7DaysAvg || '-'}</ShadowTableColumn>
        <td>{item?.summary?.painReported?.throwingDate || '-'}</td>
        <td>{item?.summary?.painReported?.throwingRelated || '-'}</td>
        <LocationWrapper
          theme="light"
          onMouseEnter={e => changeTooltipTwo(e, true)}
          onMouseLeave={e => changeTooltipTwo(e, false)}
          onWheel={() => useTooltipTwo({ ...tooltip, visible: false })}>
          {formatLocationCell(item, 'painReported', 'throwingLocation', takeInitials, ' - ')}
          <Tooltip data={item?.summary?.painReported?.throwingLocation} tooltip={tooltipTwo} />
        </LocationWrapper>
        <td>{item?.summary?.painReported?.throwingPainScale || '-'}</td>
        <ShadowTableColumn>{item?.summary?.painReported?.testingDate || '-'}</ShadowTableColumn>
        <LocationWrapper
          theme="light"
          onMouseEnter={e => changeTooltipThree(e, true)}
          onMouseLeave={e => changeTooltipThree(e, false)}
          onWheel={() => useTooltipThree({ ...tooltip, visible: false })}>
          {formatLocationCell(item, 'painReported', 'testingPain', takeInitials, ' ')}
          <Tooltip data={item?.summary?.painReported?.testingPain} tooltip={tooltipThree} />
        </LocationWrapper>

      </tr>
    );
  };
  function closeSorts() {
    usePopup('');
  }
  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }
  return (
    <TableWellness data-cy={dataCy} minWidth={minWidth}>
      <thead>
        <tr>
          <StickyTableHead topPosition="0px"></StickyTableHead>
          <StickyTableHead topPosition="0px" colSpan={8}>
            DAILY CHECK IN
          </StickyTableHead>
          <StickyTableHead topPosition="0px" colSpan={9}>
            PAIN REPORTED
          </StickyTableHead>
        </tr>
        <tr>
          <StickyTableHead topPosition="21px">PLAYERS</StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={4}>
            ARM
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={2}>
            BODY
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={2}>
            SLEEP
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={4}>
            THROWING
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={2}>
            TESTING
          </StickyTableHead>
        </tr>
        <tr>
          {sortingTableHead('Name', 'firstName', ['firstName'], handleSort)}
          {sortingTableHead('Date', 'dateDailyCheckIn', ['summary', 'dailyCheckIn', 'date'], toggleSortDate)}
          <PopUpGenerator
            name="currentArm"
            title="Current"
            data={[...dataTableContent]}
            location={['summary', 'dailyCheckIn', 'armCurrent']}
            visible={popUp}
            changeFunction={changeTable}
            statusLocation={['summary', 'dailyCheckIn', 'armStatus']}
            toggleFunction={togglePopUp}
          />

          {sortingTableHead('Location', 'armLocation', ['summary', 'dailyCheckIn', 'armLocation', 0], toggleSortString)}
          {sortingTableHead('7 Days Avg.', '7daysavgArm', ['summary', 'dailyCheckIn', 'armLast7DaysAvg'], toggleSortNumber)}

          <PopUpGenerator
            name="currentBody"
            title="Current"
            data={[...dataTableContent]}
            location={['summary', 'dailyCheckIn', 'bodyCurrent']}
            visible={popUp}
            changeFunction={changeTable}
            statusLocation={['summary', 'dailyCheckIn', 'bodyStatus']}
            toggleFunction={togglePopUp}
          />
          {sortingTableHead('7 Days Avg.', '7daysavgbody', ['summary', 'dailyCheckIn', 'bodyLast7DaysAvg'], toggleSortNumber)}
          <PopUpGenerator
            name="currentSleep"
            title="Current"
            data={dataTableContent}
            location={['summary', 'dailyCheckIn', 'sleepCurrent']}
            visible={popUp}
            changeFunction={changeTable}
            statusLocation={['summary', 'dailyCheckIn', 'sleepStatus']}
            toggleFunction={togglePopUp}
          />
          {sortingTableHead('7 Days Avg.', 'sleep7DaysAvg', ['summary', 'dailyCheckIn', 'sleepLast7DaysAvg'], toggleSortNumber)}

          <StickyTableHead topPosition="64px">
            <span>Date</span>
          </StickyTableHead>
          <StickyTableHead topPosition="64px">
            <span>Throwing Related</span>
          </StickyTableHead>
          <StickyTableHead topPosition="64px">
            <span>Location</span>
          </StickyTableHead>
          <StickyTableHead topPosition="64px">
            <span>Pain Scale</span>
          </StickyTableHead>
          <StickyTableHead topPosition="64px">
            <span>Date</span>
          </StickyTableHead>
          <StickyTableHead topPosition="64px">
            <span>Testing Pain</span>
          </StickyTableHead>
        </tr>
      </thead>
      <tbody onClick={() => closeSorts()}>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>
              <TableAverage>Team Average</TableAverage>
            </td>
            <td>{'-'}</td>
            <ShadowSummaryColumn>{teamAverage?.dailyCheckIn?.armCurrent || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{'-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.dailyCheckIn?.armLast7DaysAvg || '-'}</ShadowSummaryColumn>

            <td>{teamAverage?.dailyCheckIn?.bodyCurrent || '-'}</td>
            <td>{teamAverage?.dailyCheckIn?.bodyLast7DaysAvg || '-'}</td>
            <ShadowSummaryColumn>{teamAverage?.dailyCheckIn?.sleepCurrent || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.dailyCheckIn?.sleepLast7DaysAvg || '-'}</ShadowSummaryColumn>
            <td>{'-'}</td>
            <td>{'-'}</td>
            <td>{'-'}</td>
            <td>{'-'}</td>
            <ShadowSummaryColumn>{'-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{'-'}</ShadowSummaryColumn>
          </TeamAverageRow>
        )}
        {table?.length > 0 ? (
          table
            .filter(el => {
              const playerName: string = el.firstName || '';
              const playerLast: string = el.lastName || '';
              const name = `${playerName} ${playerLast}`;
              return name.toLocaleLowerCase().includes(filter.toLowerCase());
            })
            .map((item, index) => {
              return <GenerateColumn index={index} item={item} key={item._id + index} />;
            })
        ) : (
          <tr>
            <td colSpan={15}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableWellness>
  );
};
